import React, { useEffect } from "react";
import UpcomingJobCard from "./components/UpcomingJobCard";
import { useDispatch, useSelector } from "react-redux";
import { fetchUpcomingJobsForVendor } from "../../../redux/slices/vendorJobSlice";

const UpcomingJobs = () => {
  const dispatch = useDispatch();
  const { vendorId } = useSelector((state) => state.vendorAuth);
  useEffect(() => {
    if (vendorId) {
      dispatch(fetchUpcomingJobsForVendor(vendorId));
    }
  }, [vendorId, dispatch]);
  return (
    <div>
      <UpcomingJobCard />
    </div>
  );
};

export default UpcomingJobs;
